'use client';

import { useState } from 'react';
import { tw } from '@tw';

// The page link's pill (`PageLink`): the address on the card colour, Copy in ink, a hairline apart.
const SEG = 'flex min-h-11 items-center px-4 text-badge font-semibold';

export function CopyAddress({
  address,
  display = address,
}: {
  address: string;
  /** What is shown, when it differs from what is copied (an invite link without its https://). */
  display?: string;
}) {
  const [copied, setCopied] = useState(false);
  return (
    <div className="inline-flex max-w-full gap-px self-start overflow-hidden rounded-full bg-[var(--sf-line)]">
      <code className="sf-num flex min-h-11 min-w-0 items-center truncate bg-[var(--sf-card)] px-4 font-sans text-[16px] font-semibold text-[var(--sf-ink)]">
        {display}
      </code>
      <button
        type="button"
        onClick={() => void navigator.clipboard.writeText(address).then(() => setCopied(true))}
        className={tw(
          SEG,
          'min-w-[5.5rem] shrink-0 justify-center bg-[var(--sf-ink)] px-5 text-p-3 font-bold text-[var(--sf-page)] transition-opacity active:opacity-80'
        )}
      >
        {copied ? 'Copied' : 'Copy'}
      </button>
    </div>
  );
}
